import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group fixed right-0 bottom-11 z-10 cursor-pointer xl:-bottom-4',
    image:
      'relative inline-block transition-opacity duration-200 ease-out max-md:max-w-30'
  }
});
